import { useState } from 'react';
import {
  Box, Button, Flex, FormControl, FormLabel, Heading, Input, Text, useColorModeValue, ButtonGroup,
} from '@chakra-ui/react';
import DefaultAuth from 'layouts/auth/Default';
import illustration from 'assets/img/auth/auth.png';
import { useAuth } from 'lib/auth';
import GoogleButton from 'components/vdh/GoogleButton';

export default function SignIn() {
  const textColor = useColorModeValue('navy.700', 'white');
  const { loginParent, loginAdmin, loginGoogle } = useAuth();
  const [mode, setMode] = useState('parent'); // 'parent' | 'admin'
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  async function submit(e) {
    e.preventDefault();
    setBusy(true); setErr('');
    try {
      if (mode === 'admin') await loginAdmin(username.trim(), password);
      else await loginParent(email.trim().toLowerCase(), password);
    } catch (e) { setErr(e.message || 'Đăng nhập thất bại'); setBusy(false); }
  }

  async function onGoogle(idToken) {
    setBusy(true); setErr('');
    try { await loginGoogle(idToken); }
    catch (e) { setErr(e.message || 'Đăng nhập Google thất bại'); setBusy(false); }
  }

  return (
    <DefaultAuth illustrationBackground={illustration} image={illustration}>
      <Flex maxW={{ base: '100%', md: '420px' }} w="100%" mx={{ base: 'auto', lg: '0px' }} me="auto"
            h="100%" alignItems="start" justifyContent="center" flexDirection="column"
            px={{ base: '25px', md: '0px' }} mt={{ base: '40px', md: '14vh' }}>
        <Box me="auto">
          <Heading color={textColor} fontSize="36px" mb="8px">Vui Để Học</Heading>
          <Text color="secondaryGray.600" fontSize="md">
            {mode === 'admin' ? 'Đăng nhập quản trị hệ thống.' : 'Cổng theo dõi học tập cho ba mẹ.'}
          </Text>
        </Box>
        <Flex direction="column" w="100%" mt="26px">
          <ButtonGroup isAttached mb="20px" w="100%">
            <Button flex="1" colorScheme={mode === 'parent' ? 'brand' : 'gray'} variant={mode === 'parent' ? 'solid' : 'outline'} onClick={() => { setMode('parent'); setErr(''); }}>Phụ huynh</Button>
            <Button flex="1" colorScheme={mode === 'admin' ? 'brand' : 'gray'} variant={mode === 'admin' ? 'solid' : 'outline'} onClick={() => { setMode('admin'); setErr(''); }}>Quản trị</Button>
          </ButtonGroup>
          <form onSubmit={submit}>
            {mode === 'parent' ? (
              <>
                <FormControl mb="16px">
                  <FormLabel fontSize="sm" fontWeight="600" color={textColor}>Email</FormLabel>
                  <Input type="email" required placeholder="ba.me@email.com" size="lg" value={email} onChange={(e) => setEmail(e.target.value)} />
                </FormControl>
                <FormControl mb="16px">
                  <FormLabel fontSize="sm" fontWeight="600" color={textColor}>Mật khẩu</FormLabel>
                  <Input type="password" required placeholder="••••••••" size="lg" value={password} onChange={(e) => setPassword(e.target.value)} />
                  <Text fontSize="xs" color="secondaryGray.600" mt="6px">Chưa có mật khẩu? Đăng nhập bằng Apple/Google trong app rồi đặt mật khẩu ở phần Hồ sơ.</Text>
                </FormControl>
              </>
            ) : (
              <>
                <FormControl mb="16px">
                  <FormLabel fontSize="sm" fontWeight="600" color={textColor}>Tên đăng nhập</FormLabel>
                  <Input type="text" required placeholder="admin" size="lg" value={username} onChange={(e) => setUsername(e.target.value)} />
                </FormControl>
                <FormControl mb="16px">
                  <FormLabel fontSize="sm" fontWeight="600" color={textColor}>Mật khẩu</FormLabel>
                  <Input type="password" required placeholder="••••••••" size="lg" value={password} onChange={(e) => setPassword(e.target.value)} />
                </FormControl>
              </>
            )}
            {err && <Text color="red.500" fontSize="sm" mb="12px">⚠️ {err}</Text>}
            <Button type="submit" colorScheme="brand" w="100%" h="52px" isLoading={busy}>
              {mode === 'admin' ? 'Đăng nhập quản trị' : 'Đăng nhập'}
            </Button>
          </form>
          {mode === 'parent' && (
            <Flex direction="column" align="center" w="100%" mt="20px">
              <Flex align="center" w="100%" mb="16px" color="secondaryGray.600">
                <Box flex="1" h="1px" bg="secondaryGray.300" />
                <Text mx="12px" fontSize="sm">hoặc</Text>
                <Box flex="1" h="1px" bg="secondaryGray.300" />
              </Flex>
              <GoogleButton onCredential={onGoogle} onError={(e) => setErr(e.message)} />
              <Text fontSize="xs" color="secondaryGray.600" mt="10px" textAlign="center">
                Đăng nhập Google cần đã dùng app trên máy con trước.
              </Text>
            </Flex>
          )}
        </Flex>
      </Flex>
    </DefaultAuth>
  );
}
